import React, { useState } from 'react';
import CalcShell from '../CalcShell';

const PAIRS = [[1000,'M'],[900,'CM'],[500,'D'],[400,'CD'],[100,'C'],[90,'XC'],[50,'L'],[40,'XL'],[10,'X'],[9,'IX'],[5,'V'],[4,'IV'],[1,'I']];
function toRoman(n) { let r=''; for (const [v,s] of PAIRS) { while (n >= v) { r += s; n -= v; } } return r; }
function fromRoman(s) {
  const map = { I:1, V:5, X:10, L:50, C:100, D:500, M:1000 };
  let sum = 0;
  for (let i = 0; i < s.length; i++) {
    const cur = map[s[i].toUpperCase()]; const nxt = map[s[i+1]?.toUpperCase()];
    if (!cur) return NaN;
    if (nxt && cur < nxt) sum -= cur; else sum += cur;
  }
  return sum;
}

export default function RomanNumeralCalc() {
  const [dec, setDec] = useState(2024);
  const [rom, setRom] = useState('MMXXIV');
  // Extend Roman numeral limit using vinculum notation: overline (×1000)
  const toRomanExt = (n) => {
    if (n <= 3999) return toRoman(n);
    const thousands = Math.floor(n / 1000);
    const remainder = n % 1000;
    return `[${toRoman(thousands)}]` + toRoman(remainder);
  };
  return (
    <CalcShell look="cnet" title="Roman Numeral Converter" subtitle="Convert between decimal numbers and Roman numerals (up to 3,999,999 using vinculum notation).">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="field"><label>Decimal (1 – 3,999,999)</label><input type="number" value={dec} onChange={e => { setDec(+e.target.value || 0); setRom(toRomanExt(+e.target.value || 0)); }} data-testid="rn-dec"/></div>
          <div className="result-panel"><div className="result-title">Roman Numeral</div><div className="result-value font-serif" data-testid="rn-roman">{dec >=1 && dec <= 3999999 ? toRomanExt(dec) : 'Out of range'}</div></div>
          <p className="text-xs text-slate-500 mt-2">[N] = N × 1000 (vinculum / overline notation).</p>
        </div>
        <div>
          <div className="field"><label>Roman Numeral</label><input value={rom} onChange={e => { setRom(e.target.value.toUpperCase()); setDec(fromRoman(e.target.value.replace(/[\[\]]/g,'')) || 0); }} className="font-mono uppercase" /></div>
          <div className="result-panel"><div className="result-title">Decimal</div><div className="result-value">{isNaN(fromRoman(rom.replace(/[\[\]]/g,''))) ? '—' : fromRoman(rom.replace(/[\[\]]/g,''))}</div></div>
          <a href="/calc/roman-numeral-date" className="text-sm text-blue-600 underline mt-3 inline-block">→ Convert a date to Roman Numerals</a>
        </div>
      </div>
    </CalcShell>
  );
}
